
import jQuery from 'jquery';

jQuery(document).ready(function() {
  /* Easy Scroll */
  var $root = jQuery('html, body');
  jQuery('.single-sfwd-courses .btn-start-course').on('click', function(e) {
      e.preventDefault();
      var href = jQuery.attr(this, 'href');
      $root.animate({
	scrollTop: jQuery(href).offset().top
      }, 700, function() {
	window.location.hash = href;
      });
      return false;
  });
});

